
<template>  
    <Arquivo @siga-lote-cadastro="cadastradosiga" :perfis="perfis" v-if="matricularlote"/>  
    <Sgpm @sgpm-lote-cadastro="cadastradosgpm" :perfis="perfis" v-if="matricularlotesgpm"/>  
    <CardRh :processando="processando">  
        <div class="card-header border-0">
			<h6 class="card-title align-items-start flex-column"> </h6>
			<div class="card-toolbar m-0">
                
                 
                <button type="button" class="btn btn-sm btn-light border border-success" title="getSgbBaixadoAindaNoSiades"  @click="getSgbBaixadoAindaNoSiades"> 
                    <span class="menu-icon"><i class="fa fa-file-excel fa-2x bi"></i></span> SgbBaixadoAindaNoSiades
                </button>    
                 
                <button type="button" class="btn btn-sm btn-light border border-success" title="getSgbSiadesForaCaixa"  @click="getSgbSiadesForaCaixa"> 
                    <span class="menu-icon"><i class="fa fa-file-excel fa-2x bi"></i></span> SgbSiadesForaCaixa
                </button>    
                <button type="button" class="btn btn-sm btn-light border border-success" title="getSomenteSgb"  @click="getSomenteSgb"> 
                    <span class="menu-icon"><i class="fa fa-file-excel fa-2x bi"></i></span> SomenteSgb
                </button>   
                <button type="button" class="btn btn-sm btn-light border border-success" title="getSomenteSIADES"  @click="getSomenteSIADES"> 
                    <span class="menu-icon"><i class="fa fa-file-excel fa-2x bi"></i></span> SomenteSIADES
                </button>   
                <button type="button" class="btn btn-sm btn-light border border-success" title="getSGBComumSIADES"  @click="getSGBComumSIADES"> 
                    <span class="menu-icon"><i class="fa fa-file-excel fa-2x bi"></i></span> SGBComumSIADES
                </button>  
                <button type="button" class="btn btn-sm btn-light border border-success" title="getSGB"  @click="getSGB"> 
                    <span class="menu-icon"><i class="fa fa-file-excel fa-2x bi"></i></span> SGB
                </button>   
                <button type="button" class="btn btn-sm btn-light border border-success" title="getSIADES"  @click="getSIADES"> 
                    <span class="menu-icon"><i class="fa fa-file-excel fa-2x bi"></i></span> SIADES
                </button>   
                 
			</div>

            <div class="card-toolbar m-0"> 
                <button type="button" class="btn btn-sm btn-light border border-success" title="Matricular Lote"  @click="ativarmatriculalotesgpm"> 
                    <span class="menu-icon"><i class="fa fa-plus fa-2x bi"></i></span> Inserir Sgpm Lote 
                </button>   
                <button type="button" class="btn btn-sm btn-light border border-success" title="Matricular Lote"  @click="ativarmatriculalote"> 
                    <span class="menu-icon"> <i class="fa fa-plus fa-2x bi"></i> </span> Inserir Siga Lote 
                </button>   
                <button type="button" class="btn btn-sm btn-pmes-danger border border-danger" title="excluir Tudo"  @click="excluirTudo"> 
                    <span class="menu-icon"> <i class="fa fa-trash fa-2x bi"></i> </span> excluirTudo 
                </button>   
			</div>

        </div> 
        <KDataTable :reload="reloadDatatable" :config="config"  @tableatualizada="tableatualizada( $event )"  :pesquisar="true"  >  
            <th pesquisavel style="min-width:60px">Patrimonio</th> 
            <th pesquisavel style="min-width:60px">NumeroSerie</th> 
            <th pesquisavel style="min-width:60px">NumeroSerieSGPM</th> 
            <th pesquisavel style="min-width:60px">StatusSGPM</th> 
            <th pesquisavel style="min-width:60px">Marca</th> 
            <th pesquisavel style="min-width:60px">MarcaSGPM</th> 
            <th pesquisavel style="min-width:60px">Estado</th> 
            <th pesquisavel style="min-width:60px">Setor</th> 
            <th pesquisavel style="min-width:60px">ValorLiquido</th>  
            <th style="min-width:130px" class="text-center">Ações</th> 
            <template v-slot:filtros>   
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                    <div class="mb-2">
                        <label for="NumeroPatrimonio" class="form-label">NumeroPatrimonio</label>
                        <input  @keyup="apertouEnter"  type="text" data-kt-docs-table-filter="NumeroPatrimonio" class="form-control form-control-solid" placeholder="NumeroPatrimonio"/>
                    </div> 
                </div>   
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                    <div class="mb-2">
                        <label for="tipo" class="form-label">tipo</label>
                        <input  @keyup="apertouEnter"  type="text" data-kt-docs-table-filter="tipo" class="form-control form-control-solid" placeholder="tipo"/>
                    </div> 
                </div>   
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2" >
                    <div class="mb-2"> 
                        <label  for="isSiga" class="form-label">isSiga:</label>  
                        <Multiselect @change="refreshTable" :options="limimar_select" :searchable="true"  v-model="isSiga" ></Multiselect>    
                        <input  data-kt-docs-table-filter="isSiga" v-model="isSiga" hidden/>  
                    </div> 
                </div> 
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2" >
                    <div class="mb-2"> 
                        <label  for="isSgb" class="form-label">isSgb:</label>  
                        <Multiselect @change="refreshTable" :options="limimar_select" :searchable="true"  v-model="isSgb" ></Multiselect>    
                        <input  data-kt-docs-table-filter="isSgb" v-model="isSgb" hidden/>  
                    </div> 
                </div> 
            </template>
        </KDataTable>    
    </CardRh>   
</template>

<script lang="ts"> 
	import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';    
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options  } from "vue-class-component";     
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
	import $ from "jquery"    
    import PatrimonioService from   "@/service/v1/sigap/PatrimonioService"  
    import Multiselect from '@vueform/multiselect'
    import Arquivo from   "./File.vue" 
    import Sgpm from   "./FileSgpm.vue" 

    @Options({
        name: "MatriculaIndex",
        components: { Sgpm, Arquivo, CardRh , KDataTable ,  Multiselect },   
    }) 
    export default class MatriculaIndex extends IndexModelTable {
         
        public isSiga  = null;
        public isSgb  = null; 
        public matricularlote  = false;
        public matricularlotesgpm  = false;
 
        public ativarmatriculalote(){
            this.matricularlote= true;
        }
          
        public cadastradosiga(item){
            this.matricularlote= false;
            this.modeloAlterado(item);
        }
 
        get limimar_select(){
            return [ 
                { value: true , label: "Sim" } ,
                { value: false , label: "Não" } ,
            ];  
        }
         
        public ativarmatriculalotesgpm(){
            this.matricularlotesgpm= true;
        }
        
        public cadastradosgpm(item){
            this.matricularlotesgpm= false;
            this.modeloAlterado(item);
        }
   
        public refreshTable(){ 
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable ; 
            }, 300); 
        }
         
        public apertouEnter(e){ 
            if(e.key === 'Enter' || e.keyCode === 13){
                this.refreshTable();
            }
        }
 
        created(){
            this.service = new PatrimonioService();   
            this.config.ajax = { 
                url: this.service.getApiUrl()  ,
                data: function ( d ) {    
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length, 
                        "numeroPatrimonio": () => (document.querySelector('[data-kt-docs-table-filter="NumeroPatrimonio"]')! as HTMLInputElement).value ,   
                        "tipo": () => (document.querySelector('[data-kt-docs-table-filter="tipo"]')! as HTMLInputElement).value ,   
                        "isSiga": () => (document.querySelector('[data-kt-docs-table-filter="isSiga"]')! as HTMLInputElement).value ,   
                        "isSgb": () => (document.querySelector('[data-kt-docs-table-filter="isSgb"]')! as HTMLInputElement).value ,   
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 
  
            this.config.columns = [ 
                { data: 'numeroPatrimonio', name: 'numeroPatrimonio' }, 
                { data: 'numeroSerie', name: 'numeroSerie' }, 
                { data: 'numeroSerieSGPM', name: 'numeroSerieSGPM' }, 
                { data: 'statusSGPM', name: 'statusSGPM' }, 
                { data: 'marca', name: 'marca' }, 
                { data: 'marcaSGPM', name: 'marcaSGPM' }, 
                { data: 'estadoConservacao', name: 'estadoConservacao' }, 
                { data: 'setor', name: 'setor' }, 
                { data: 'valorLiquido', name: 'valorLiquido' }, 
                
            ];
            
            this.pushColunaAcoes()
            this.config.columnDefs = [  
                 
            ];   
            
        }     
          
        public tableatualizada( event ) {    
            $('[btn-show]').click(  (btn) => {   
                let id =   $(btn.currentTarget).data('id');    
                window.open('/#/sigap/matricula/' +  id, "_blank" ) 
            }); 
        } 
          
        public excluirTudo() {  
            this.processando = true; 
            this.service.excluirTudo( )
            .then(response => {  
                this.processando = false; 
            })
            .catch(error => {  
                this.processando = false; 
                console.log(error);
            })
            .finally( () => {
                this.refreshTable();
                this.processando = false;
            });    
        } 
        
        
        public getSIADES() {  
            window.open( this.service.getApiUrl() + '/Excel/Siades?token=' +  this.token );
		}
        
        public getSGB() {  
            window.open( this.service.getApiUrl() + '/Excel/Sgb?token=' +  this.token );
		}
        
        public getSGBComumSIADES() {  
            window.open( this.service.getApiUrl() + '/Excel/SgbComumSiades?token=' +  this.token );
		}
  
        public getSomenteSIADES() {  
            window.open( this.service.getApiUrl() + '/Excel/SomenteSiades?token=' +  this.token );
		}
  
        public getSomenteSgb() {  
            window.open( this.service.getApiUrl() + '/Excel/SomenteSgb?token=' +  this.token );
		}
 
  
        public getSgbSiadesForaCaixa() {  
            window.open( this.service.getApiUrl() + '/Excel/SgbSiadesForaCaixa?token=' +  this.token );
		}
 
  
        public getSgbBaixadoAindaNoSiades() {  
            window.open( this.service.getApiUrl() + '/Excel/SgbBaixadoAindaNoSiades?token=' +  this.token );
		}
 

    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    }
    .card-header{
        min-height: 50px;
    }
</style>